<template>
  <div
    ref="feature-container"
    class="my-6 md:my-0 transform hover:scale-105 transition-all duration-700 cursor-pointer"
    @click="onClick"
  >
    <feature-title :title="'mitmeleheline'" :is-selected="isSelected" />
    <div class="rounded-md">
      <div
        class="feature-wrapper flex flex-wrap items-center justify-center rounded-md shadow-md relative"
      >
        <img ref="imgRef1" src="../../../assets/multipage1.png" class="absolute w-full" />
        <img ref="imgRef2" src="../../../assets/multipage2.png" class="absolute w-full" />
        <img ref="imgRef3" src="../../../assets/multipage3.png" class="absolute w-full" />
        <img ref="imgRef4" src="../../../assets/multipage4.png" class="absolute w-full" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import calculatorFeature from "@/mixins/calculatorFeature";
import FeatureTitle from "@/components/calculator-steps/utils/FeatureTitle";

export default {
  name: "StructureMultiPage",
  mixins: [calculatorFeature],
  components: {
    FeatureTitle,
  },
  computed: {
    imgRef1: function () {
      return this.$refs["imgRef1"];
    },
    imgRef2: function () {
      return this.$refs["imgRef2"];
    },
    imgRef3: function () {
      return this.$refs["imgRef3"];
    },
    imgRef4: function () {
      return this.$refs["imgRef4"];
    },
  },
  mounted() {
    gsap.set(this.imgRef1, { autoAlpha: 0 });
    gsap.set(this.imgRef2, { autoAlpha: 0 });
    gsap.set(this.imgRef3, { autoAlpha: 0 });
    gsap.set(this.imgRef4, { autoAlpha: 0 });
    const tl = gsap.timeline({
      repeat: -1,
      yoyo: true,
      defaults: { duration: 1.5, ease: "slow" },
    });
    tl.to(this.imgRef1, { autoAlpha: 1 });
    tl.to(this.imgRef1, { autoAlpha: 0 });
    tl.to(this.imgRef2, { autoAlpha: 1 });
    tl.to(this.imgRef2, { autoAlpha: 0 });
    tl.to(this.imgRef3, { autoAlpha: 1 });
    tl.to(this.imgRef3, { autoAlpha: 0 });
    tl.to(this.imgRef4, { autoAlpha: 1 });
    tl.to(this.imgRef4, { autoAlpha: 0 });
  },
};
</script>

<style scoped>
.feature-wrapper {
  height: 206px;
  overflow: hidden;
}
</style>
